import { SvgIcon, SvgIconProps } from '@mui/material';

export function ArrowUpIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="u:arrow-up">
          <path
            id="Vector"
            d="M17.7102 11.29L12.7102 6.29002C12.6151 6.19898 12.5029 6.12761 12.3802 6.08002C12.1367 5.98 11.8636 5.98 11.6202 6.08002C11.4974 6.12761 11.3853 6.19898 11.2902 6.29002L6.29019 11.29C6.19695 11.3833 6.12299 11.4939 6.07253 11.6158C6.02207 11.7376 5.99609 11.8682 5.99609 12C5.99609 12.2663 6.10188 12.5217 6.29019 12.71C6.47849 12.8983 6.73388 13.0041 7.00019 13.0041C7.26649 13.0041 7.52188 12.8983 7.71019 12.71L11.0002 9.41002V17C11.0002 17.2652 11.1055 17.5196 11.2931 17.7071C11.4806 17.8947 11.735 18 12.0002 18C12.2654 18 12.5198 17.8947 12.7073 17.7071C12.8948 17.5196 13.0002 17.2652 13.0002 17V9.41002L16.2902 12.71C16.3831 12.8037 16.4937 12.8781 16.6156 12.9289C16.7375 12.9797 16.8682 13.0058 17.0002 13.0058C17.1322 13.0058 17.2629 12.9797 17.3848 12.9289C17.5066 12.8781 17.6172 12.8037 17.7102 12.71C17.8039 12.6171 17.8783 12.5065 17.9291 12.3846C17.9798 12.2627 18.006 12.132 18.006 12C18.006 11.868 17.9798 11.7373 17.9291 11.6154C17.8783 11.4936 17.8039 11.383 17.7102 11.29Z"
            fill="currentcolor"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
